<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></TsMenuButton>
      <div class="h100-140 h-scroll" style="padding-top: 30px;">
        <RegisterCountByTypeChart ref='registerCountByTypeChart'></RegisterCountByTypeChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import RegisterCountByTypeChart from '../../components/tsConfig/RegisterCountByTypeStatistics/RegisterCountByTypeChart';

export default {
  name: 'RegisterCountByTypeStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    RegisterCountByTypeChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.registerServiceStatistics')}/${this.$t('TS.registerCountStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.registerCountByTypeChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
